// app-pages/PaymentsPage/CryptoPaymentsModal/CryptoPaymentModal.tsx
"use client";
import { Flex, Text, Image, Button } from "@chakra-ui/react";
import { useAppContext } from "hooks";
import { useCreatePayment } from "./queries";
import Bitcoin from "@public/Bitcoin 1.png";

declare const gtag: Function;

const CryptoPaymentModal = ({ price, plan }: { price: number; plan: string }) => {
  const { profile } = useAppContext();
  const { data } = useCreatePayment(price, plan, profile?.id);

  return (
    <Flex
      w="100%"
      align="center"
      direction="column"
      //mt="10px"
    >
      <a style={{ width: "100%" }} href={data?.invoice_url} target="_blank">
        <Button
          onClick={() =>
            gtag("event", "start_crypto_payment", {
              event_category: "Crypto Payments",
              event_label: "Initiate Payment",
              plan: { plan },
              value: { price },
            })
          }
          isDisabled={plan !== "expert"}
          position="relative"
          _hover={plan !== "expert" ? {} : { opacity: 0.9 }}
          _active={plan !== "expert" ? {} : { opacity: 0.8 }}
          bg="black"
          w="100%"
          size="lg"
        >
          <Flex w="100%" justify="center">
            <Text color="white">Pay with Crypto</Text>
          </Flex>
          <Image
            maxW="25px"
            w="5vw"
            position="absolute"
            top="auto"
            bottom="auto"
            right="15px"
            src={Bitcoin.src}
          />
        </Button>
        {plan !== "expert" && (
          <Text textAlign="center" fontSize="12px" mt="5px">
            Crypto payment available only for 500 credits
          </Text>
        )}
      </a>
    </Flex>
  );
};

export default CryptoPaymentModal;
